import Skeleton from '@mui/material/Skeleton'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

// eslint-disable-next-line react/prop-types
const GridSkeleton = ({ items }) => {
  return (
    <Grid container spacing={2}>
      {/* eslint-disable-next-line react/prop-types */}
      {items.map((item, key) => {
        return (
          <Grid key={key} item xs={12} sm={12} md={4} lg={4}>
            <Card style={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
              <Skeleton variant="rectangular" width="100%" height={220} />
              <div style={{ width: '100%' }}>
                <Skeleton style={{ marginLeft: '25%' }} width="50%" height={60} />
                <div style={{ display: 'flex', marginLeft: '25%', width: '50%', justifyContent: 'space-between' }}>
                  <Skeleton variant="circular" width={30} height={30} />
                  <Skeleton variant="circular" width={30} height={30} />
                  <Skeleton variant="circular" width={30} height={30} />
                  <Skeleton variant="circular" width={30} height={30} />
                </div>
                <div style={{ margin: '1rem' }}>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton width="60%" />
                </div>
                <Skeleton style={{ marginLeft: '25%' }} width="50%" height={60} />
                <Skeleton width="100%" height={60} style={{ marginBottom: '-11px' }}/>
              </div>
            </Card>
          </Grid>
        )
      })}
    </Grid>
  )
}
// eslint-disable-next-line react/prop-types
const ListSkeleton = ({ items }) => {
  return (
    <Grid container spacing={2}>
      {/* eslint-disable-next-line react/prop-types */}
      {items.map((item, key) => {
        return (
          <Grid key={key} item xs={12} sm={12} md={12} lg={12}>
            <Card style={{ padding: 0, display: 'flex', flexDirection: 'row' }}>
              <Skeleton variant="rectangular" width={400} height={220} />
              <div style={{ width: '100%' }}>
                <div style={{ padding: 0, display: 'flex', flexDirection: 'row', height: 171 }}>
                  <div style={{ width: '50%' }}>
                    <Skeleton style={{ marginLeft: '25%' }} width="50%" height={60} />
                    <div style={{ display: 'flex', marginLeft: '25%', width: '50%', justifyContent: 'space-between' }}>
                      <Skeleton variant="circular" width={30} height={30} />
                      <Skeleton variant="circular" width={30} height={30} />
                      <Skeleton variant="circular" width={30} height={30} />
                      <Skeleton variant="circular" width={30} height={30} />
                    </div>
                  </div>
                  <div style={{ margin: '1rem', width: '50%' }}>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton width="60%" />
                  </div>
                </div>

                <Skeleton width="100%" height={60} style={{ marginBottom: '-11px' }}/>
              </div>
            </Card>
          </Grid>
        )
      })}
    </Grid>
  )
}

// eslint-disable-next-line react/prop-types
const UnitSkeleton = ({ repeat, type }) => {
  const items = Array.apply(null, { length: repeat }).map(Number.call, Number)
  return type === 'grid' ? <GridSkeleton items={items}/> : <ListSkeleton items={items}/>
}

export default UnitSkeleton
